import React, { useState } from "react";
import axios from "axios";
import { GeneralButton } from "../../../components";
import { useTranslation } from "react-i18next";
import whatsapp_icon from "../../../assets/images/icons/white_whatsapp.svg";
import { EndPoints } from "../../../Constants/endpoints";
import { useToast } from "../../../Services/ToastContext";
import { AppConfig } from "../../../api/config/config";

function SendViaWhatsappBtn({ id }: { id?: string | number }) {
  const { t } = useTranslation();
  const { showToast } = useToast();

  const [isLoading, setIsLoading] = useState(false);

  const handleSendViaWhatsApp = async () => {
    // Open immediately to avoid popup blocking
    const whatsappWindow = window.open("about:blank", "_blank");

    try {
      setIsLoading(true);

      const lang = localStorage.getItem("i18nextLng")?.slice(0, 2) || "en";

      const token = localStorage.getItem("token") || "";

      const response = await axios({
        method: "POST",

        url:
          `${AppConfig.BASE_API_URL}` +
          `${EndPoints.DownloadPrescription}/${id}`,

        data: {},

        headers: {
          "Accept-Language": lang,
          Authorization: token,
          "Content-Type": "application/json",
        },

        responseType: "arraybuffer",

        timeout: 60000,
      });

      if (!response.data) {
        throw new Error("EMPTY_RESPONSE");
      }

      const blob = new Blob([response.data], {
        type: "application/pdf",
      });

      if (blob.size === 0) {
        throw new Error("EMPTY_PDF");
      }

      const fileName = `prescription_${id ?? Date.now()}.pdf`;

      // Download PDF
      const fileUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");

      link.href = fileUrl;
      link.download = fileName;
      link.style.display = "none";

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);

      setTimeout(() => {
        URL.revokeObjectURL(fileUrl);
      }, 5000);

      // Open WhatsApp Web
      if (whatsappWindow) {
        whatsappWindow.location.href = "https://web.whatsapp.com/";
      } else {
        window.open("https://web.whatsapp.com/", "_blank");
      }

      showToast(
        "Prescription downloaded. Select a chat in WhatsApp and attach the downloaded PDF.",
        "success",
      );
    } catch {
      whatsappWindow?.close();

      showToast(t("failed_to_send_via_whatsapp"), "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <GeneralButton
        color="green"
        icon={whatsapp_icon}
        title={t("download_file_and_open_whatsapp")}
        onClick={handleSendViaWhatsApp}
        isLoading={isLoading}
        disabled={isLoading}
      />
    </div>
  );
}

export default SendViaWhatsappBtn;
